import React from "react";
import { Flame, Leaf, Egg } from "lucide-react";

function SpiceTag({ spice }) {
  if (!spice) return null;
  if (spice === "red")
    return (
      <span className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-red-400">
        <Flame className="w-3 h-3" /> Red
      </span>
    );
  if (spice === "green")
    return (
      <span className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-emerald-400">
        <Leaf className="w-3 h-3" /> Green
      </span>
    );
  if (spice === "both")
    return (
      <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider">
        <span className="inline-flex items-center gap-1 text-red-400"><Flame className="w-3 h-3" /> Red</span>
        <span className="text-white/30">/</span>
        <span className="inline-flex items-center gap-1 text-emerald-400"><Leaf className="w-3 h-3" /> Green</span>
      </span>
    );
  return null;
}

export default function MenuCard({ item, featured = false }) {
  return (
    <div
      data-testid={`menu-card-${item.id}`}
      className={`card-dark group relative flex flex-col p-6 md:p-7 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_18px_60px_-10px_rgba(244,187,41,0.3)] ${
        featured ? "ring-1 ring-yellow-brand/30" : ""
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <span className="w-9 h-9 rounded-full bg-yellow-brand/15 text-yellow-brand flex items-center justify-center group-hover:bg-yellow-brand group-hover:text-black transition-colors">
            <Egg className="w-4 h-4" />
          </span>
          {item.qty && (
            <span className="px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-white/5 text-white/70 border border-white/10">
              {item.qty}
            </span>
          )}
        </div>
        <span className="px-3 py-1.5 rounded-full bg-yellow-brand text-black font-extrabold text-sm shadow-[0_6px_20px_-8px_rgba(244,187,41,0.55)]">
          ${item.price.toFixed(2)}
        </span>
      </div>

      <h3 className="text-2xl md:text-[26px] font-extrabold text-white leading-tight mt-5">{item.name}</h3>
      <p className="text-white/55 text-sm mt-2 leading-relaxed flex-1">{item.desc}</p>

      <div className="mt-5 pt-4 border-t border-white/5 flex items-center justify-between min-h-[24px]">
        <SpiceTag spice={item.spice} />
      </div>

      {/* Decorative yolk */}
      <div className="pointer-events-none absolute -right-6 -bottom-6 w-24 h-24 rounded-full bg-yellow-brand/0 group-hover:bg-yellow-brand/10 blur-2xl transition-colors duration-700" />
    </div>
  );
}
